module.exports = __webpack_public_path__ + "images/share_icon_download.80ee941d.png";